import {
  get45MinIntervals,
  getSlotRulesFromStore,
  isTodayBeforeCurrentTime,
} from "../../services/utils/date-and-time.utils";
import moment from "moment-timezone";

function checkTimeslotSelectionForLateNight(datetime) {
  const hr = new Date(datetime).getHours();

  if (hr >= 0 && hr <= 6) {
    return true;
  }

  return false;
}

function isWeekendInTimezone(dateTime: Date | string, timezone: string): boolean {
  if (!dateTime || !timezone) return false;
  let dateInTimezone;
  if (typeof dateTime === 'string' && dateTime.includes('T') && dateTime.includes('Z')) {
    dateInTimezone = moment.utc(dateTime).tz(timezone);
  } else {
    dateInTimezone = moment(dateTime).tz(timezone);
  }
  const day = dateInTimezone.day();
  return day === 0 || day === 6;
}

function isShortNoticeInTimezone(dateTime: Date | string, timezone: string): boolean {
  if (!dateTime || !timezone) return false;
  const nowInTimezone = moment.tz(timezone).startOf("day");
  let dateInTimezone;
  if (typeof dateTime === 'string' && dateTime.includes('T') && dateTime.includes('Z')) {
    dateInTimezone = moment.utc(dateTime).tz(timezone).startOf("day");
  } else {
    dateInTimezone = moment(dateTime).tz(timezone).startOf("day");
  }
  const daysDifference = dateInTimezone.diff(nowInTimezone, "days");
  return daysDifference < getSlotRulesFromStore().minDaysAhead;
}

function isLateNightInTimezone(dateTime: Date | string, timezone: string): boolean {
  if (!dateTime || !timezone) return false;
  let dateInTimezone;
  if (typeof dateTime === 'string' && dateTime.includes('T') && dateTime.includes('Z')) {
    dateInTimezone = moment.utc(dateTime).tz(timezone);
  } else {
    dateInTimezone = moment(dateTime).tz(timezone);
  }
  const hour = dateInTimezone.hour();
  const minute = dateInTimezone.minute();
  const { minHour, maxHour } = getSlotRulesFromStore()?.businessHours;


  const isBeforeMorning = hour < minHour;
  const isAfterEvening = hour > maxHour || (hour === maxHour && minute > 0);

  return isBeforeMorning || isAfterEvening;
}

const validateSlots = (item: any) => {
  let isFormValid = true;
  let slotSelectionCount = 0;

  const isAllSlotsEmpty = item.slots.every(
    (itemslot: any) => !itemslot.selectedSlotTimeFrom && !itemslot.selectedSlotTimeTo
  );

  if (isAllSlotsEmpty) {
    return {
      updatedList: item,
      isFormValid: false,
      formMessage: "Please select the times",
    };
  }

  item.slots.forEach((slotsItem: any, slotsIndex: number) => {
    const overLapIndex: number[] = [];

    if (slotsItem.selectedSlotTimeFrom && slotsItem.selectedSlotTimeTo) {
      slotSelectionCount++;
    }

    item.slots.forEach((slotsItemInner: any, slotsIndexInner: number) => {
      if (
        slotsIndexInner !== slotsIndex &&
        slotsItem.selectedSlotTimeFrom &&
        slotsItem.selectedSlotTimeTo &&
        slotsItemInner.selectedSlotTimeFrom &&
        slotsItemInner.selectedSlotTimeTo &&
        moment(slotsItem.selectedSlotTimeFrom).diff(
          moment(slotsItemInner.selectedSlotTimeFrom),
          "minutes"
        ) === 0 &&
        moment(slotsItem.selectedSlotTimeTo).diff(
          moment(slotsItemInner.selectedSlotTimeTo),
          "minutes"
        ) === 0
      ) {
        overLapIndex.push(slotsIndexInner + 1);
      }
    });

    if (overLapIndex.length > 0) {
      slotsItem.error = `Matching with time ${overLapIndex.join(",")}`;
      isFormValid = false;
    } else if (
      (slotsItem.selectedSlotTimeTo && !slotsItem.selectedSlotTimeFrom) ||
      (!slotsItem.selectedSlotTimeTo && slotsItem.selectedSlotTimeFrom)
    ) {
      slotsItem.error = "From and To date are required";
      isFormValid = false;
    } else {
      slotsItem.error = "";
    }
  });

  const isSlotsValid = item.slots.every((slot: any) => !slot.error);

  if (slotSelectionCount < 3) {
    return {
      updatedList: item,
      isFormValid: false,
      formMessage: "Minimum 3 times required",
    };
  }

  return {
    updatedList: item,
    isFormValid: isSlotsValid,
    formMessage: isSlotsValid ? "" : "Please check all the selected times",
  };
};

function createSelectedClientQuestionPayload(list) {
  const obj = [];

  list.map((item) => {
    let payload = {
      ambassadorId: item.id,
    };

    obj.push(payload);
  });

  return obj;
}

function createSelectedClientSlotsPayload(item) {
  let payload = {
    availableTimeSlots: [],
  };

  payload.availableTimeSlots = item.slots
    .filter((slotItem) => {
      return slotItem.selectedSlotTimeFrom && slotItem.selectedSlotTimeTo;
    })
    .map((slotItem) => {
      return {
        from: slotItem.selectedSlotTimeFrom,
        to: slotItem.selectedSlotTimeTo,
        isTimeRange: slotItem.isTimeRange
      };
    });

  payload.availableTimeSlots = Array.from(
    new Set(
      payload.availableTimeSlots.flatMap(({ from, to, isTimeRange }) =>
        get45MinIntervals(from, to, isTimeRange)
      )
    )
  ).map((dateString) => ({
    from: dateString,
    to: new Date(new Date(dateString).getTime() + 45 * 60000),
  }));

  payload.availableTimeSlots = payload.availableTimeSlots.filter(
    (timeSlot, index, self) => {
      const idx = self.findIndex(
        (t) => new Date(t.from).getDate() === new Date(timeSlot.from).getDate() &&
          new Date(t.from).getHours() === new Date(timeSlot.from).getHours() &&
          new Date(t.from).getMinutes() === new Date(timeSlot.from).getMinutes()
      );
      return idx === index;
    }
  );

  payload.availableTimeSlots.sort((a, b) => a.from - b.from);

  return payload;
}


function getUserAvailableTimeSlots({ availableDatesArr, selectedDate }: any) {
  const date = moment(selectedDate);

  return availableDatesArr?.filter(
    (ad) =>
      moment(date).format("YYYY-MM-DD") === moment(ad).format("YYYY-MM-DD") &&
      !isTodayBeforeCurrentTime(ad)
  );
}

export {
  validateSlots,
  createSelectedClientSlotsPayload,
  checkTimeslotSelectionForLateNight,
  createSelectedClientQuestionPayload,
  getUserAvailableTimeSlots,
  isWeekendInTimezone,
  isShortNoticeInTimezone,
  isLateNightInTimezone,
};
